<script>
export default {
  props: {
    socialProfiles: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      socialMediaLinks: [
        { key: 'facebook', icon: 'facebook', link: 'https://m.me/' },
        { key: 'twitter', icon: 'twitter', link: 'https://twitter.com/' },
        { key: 'linkedin', icon: 'linkedin', link: 'https://linkedin.com/' },
        { key: 'github', icon: 'github', link: 'https://github.com/' },
        { key: 'instagram', icon: 'instagram', link: 'https://instagram.com/' },
        { key: 'tiktok', icon: 'tiktok', link: 'https://www.tiktok.com/@' },
        { key: 'telegram', icon: 'telegram', link: 'https://t.me/' },
        { key: 'line', icon: 'line', link: null },
      ],
    };
  },
  computed: {
    availableProfiles() {
      return this.socialMediaLinks.filter(
        mediaLink => !!this.socialProfiles[mediaLink.key]
      );
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <div v-if="availableProfiles.length" class="flex items-end gap-3 mx-0 my-2">
    <template v-for="profile in availableProfiles" :key="profile.key">
      <a
        v-if="profile.link"
        :href="`${profile.link}${socialProfiles[profile.key]}`"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        <fluent-icon
          :icon="`brand-${profile.key}`"
          size="16"
          class="text-n-slate-11 hover:text-n-slate-10"
        />
      </a>
      <span v-else>
        <fluent-icon
          :icon="`brand-${profile.key}`"
          size="16"
          class="text-n-slate-11"
        />
      </span>
    </template>
  </div>
</template>
